export const OvernightsPermissions = {
  default: 'User.RiskMonitoring.Overnights',
  nopBackdated: 'User.RiskMonitoring.Overnights.NopBackdatedReport',
  lpBackdated: 'User.RiskMonitoring.Overnights.LPAccountsBackdatedReport',
  autoMap: 'User.RiskMonitoring.AutoMap',
  byUniqueId: 'User.RiskMonitoring.ConsolidatedExposure.ByUniqueId',
} as const;
